export default __webpack_public_path__ + "static/media/2.264abce7.png";